import createRetailerImagePath from './createRetailerImagePath'

export default (retailer, locale) => (
  retailer?.assets?.url
  || createRetailerImagePath(locale, retailer?.slug)
)
